module.exports = __webpack_public_path__ + "static/media/NIGHT.33c8951e.png";